import Image from 'next/image'
import { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'

function NoResultsPlaceholder() {
  const { t } = useTranslation('products')

  const {
    query: { filters, price_to, price_from },
    pathname,
  } = useRouter()

  const isSearching =
    pathname === '/search' && !filters && !price_to && !price_from

  return (
    <div className="flex flex-col items-center mt-0">
      <figure className="relative w-full max-w-lg px-2 mt-4 xl:max-w-2xl 2xl:max-w-3xl">
        <Image
          alt={t('results.none')}
          src="/assets/global/no-results.svg"
          height="50%"
          width="100%"
          layout="responsive"
          quality={75}
          loading="eager"
        />
      </figure>
      <h3 className="mt-12 mb-4 text-xl max-w-[220px] 2md:max-w-full font-medium text-center 2md:text-2xl">
        {t(
          isSearching
            ? 'no_results_for_search'
            : 'no_results_for_selected_filters'
        )}
      </h3>
      <p className="text-center">
        {t(isSearching ? 'choose_other_query' : 'choose_other_filters')}
      </p>
    </div>
  )
}

export default NoResultsPlaceholder
